/* Heads Up Crush — stickhandling page behaviour.
   1) Scroll-reveal for .reveal elements.
   2) Count-up for the "Track Your Progress" stats (handles +13.4% style values).
   Loaded with defer. Scoped to the .huh-shooting wrapper. */
(function () {
  'use strict';

  var root = document.querySelector('.huh-shooting');
  if (!root) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var AUDIT = /[?&]audit/.test(window.location.search); // ?audit=1 reveals everything instantly (for screenshots)

  /* ---- Scroll reveal ---- */
  var reveals = root.querySelectorAll('.reveal');
  if (AUDIT || reduce || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('in'); });
  } else {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); ro.unobserve(e.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { ro.observe(el); });
  }

  /* ---- Count-up: animate any element with [data-count] ---- */
  function ease(p) { return 1 - Math.pow(1 - p, 3); }

  function countEl(el) {
    var raw = el.getAttribute('data-count') || el.textContent || '';
    var m = raw.match(/^([^\d-]*)(-?\d+(?:\.\d+)?)(.*)$/);
    if (!m) return;
    var prefix = m[1], target = parseFloat(m[2]), suffix = m[3];
    var decimals = (m[2].split('.')[1] || '').length;
    var dur = 1100, start = null;
    function fmt(v) { return prefix + (decimals ? v.toFixed(decimals) : Math.round(v)) + suffix; }
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      el.textContent = fmt(ease(p) * target);
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = fmt(0);
    requestAnimationFrame(step);
  }

  var statSection = root.querySelector('[data-countgroup]');
  if (statSection) {
    var targets = statSection.querySelectorAll('[data-count]');
    var fire = function () { targets.forEach(countEl); };
    if (AUDIT || reduce) {
      targets.forEach(function (el) { el.textContent = el.getAttribute('data-count') || el.textContent; });
    } else if ('IntersectionObserver' in window) {
      var fired = false;
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting && !fired) { fired = true; fire(); so.disconnect(); } });
      }, { threshold: 0.4 });
      so.observe(statSection);
    } else { fire(); }
  }
})();
